import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import RegisterRules from '.';

const paths = {
  listing: '/settings/register-rules',
  view: '/settings/register-rules/:id',
};

export default [
  <RouteIfRights
    exact
    path={paths.listing}
    component={RegisterRules}
    key={paths.listing}
    rights="register_rules"
  />,
  <RouteIfRights
    exact
    path={paths.view}
    component={RegisterRules}
    key={paths.view}
    rights="register_rules"
  />,
];
